<div class="footer-landing container">
  <div class="contact row">
    <a class="col-sm-6 mb-2 mb-sm-0" href="mailto:customer.support@eccargo.com">
      <span class="icon icon-mail"></span>
      customer.support@eccargo.com
    </a>
    <span class="col-sm-6">
      <span class="icon icon-phone"></span>
      +852 2233-2733
    </span>
  </div>
  <hr>
  <div class="copyright row">
    <div class="menu-footer col-sm-6">
      <div class="">
        <a routerLinkActive="active" routerLink="/terms-of-use">{{ 'WebsiteTermsOfUse' | translate }}</a>
      </div>
      <div class="">
        <a routerLinkActive="active" routerLink="/privacy-policy">{{ 'PrivacyPolicy' | translate }}</a>
      </div>
      <div class="">
        <a routerLinkActive="active" routerLink="/terms-and-conditions">{{ 'StandardTermsAndConditions' | translate }}</a>
      </div>
    </div>
    <div class="mt-2 mt-sm-0 col-sm-6">
      {{ 'Copyright' | translate }}
    </div>
  </div>
</div>